import { render, staticRenderFns } from "./RecordLimit.vue?vue&type=template&id=485832fa&scoped=true&"
import script from "./RecordLimit.vue?vue&type=script&lang=ts&"
export * from "./RecordLimit.vue?vue&type=script&lang=ts&"
import style0 from "./RecordLimit.vue?vue&type=style&index=0&id=485832fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485832fa",
  null
  
)

export default component.exports